"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Environment_1 = require("../../models/Environment");
const lifeConfig = {
    env: Environment_1.BuildEnvironment.Life,
    publicPath: "https://statics.teams.cdn.live.net",
    // Consumer (MSA) AAD app for the Teams web client on teams.live.com.
    // Mirrors exp-configs/common/auth/auth.json's clientId filter for env=life.
    teamsClientId: "4b3e8f46-56d3-427f-b1e2-d239b2ea6bca",
};
exports.default = lifeConfig;
